import { render } from "./ShippingCalculatorComponent.vue?vue&type=template&id=a6551d16"
const script = {}

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__